import { NavLink, useLocation } from 'react-router-dom'
import { NavCurrentUser, NavStoreName } from './nav'
import SignOutButton from '../auth/SignOutButton'
import {
  Header as LunaHeader,
  HeaderLogo,
  HeaderNav,
  HeaderMainBar,
  HeaderGlobalItem
} from '@sainsburys-tech/luna-header'
import HeaderGlobalBar from './CustomHeaderGlobalBar'
import { Display3, Caption } from '@sainsburys-tech/luna-typography'

const NavHeader = () => {
  const location = useLocation()

  const getHeaderTitle = () => {
    switch (location.pathname) {
      case '/return-to-pay':
        return 'PFS Return to Pay'
      case '/survey':
        return 'PFS'
      default:
        return 'PFS'
    }
  }
  return (
    <LunaHeader divided hasGlobalBar hasMainBar>
      <HeaderGlobalBar
        label="Group navigation"
        element="nav"
        className={undefined}
        size={undefined}
      >
        <HeaderGlobalItem align="right" drawer="true" tabbar="md">
          <span id="s-user-store">
            <NavCurrentUser /> <NavStoreName />
          </span>
        </HeaderGlobalItem>
        <HeaderGlobalItem>
          <span id="s-nav-link-signOut">
            <SignOutButton />
          </span>
        </HeaderGlobalItem>
      </HeaderGlobalBar>
      <HeaderMainBar size="nav">
        <HeaderLogo>
          <NavLink id="s-logo" to="/" style={{ textDecoration: 'none' }}>
            <Display3>
              <strong>{getHeaderTitle()}</strong>
            </Display3>
          </NavLink>
        </HeaderLogo>
        <HeaderNav align="center" drawer className="s-u-hidden@max-nav">
          <Caption>
            <NavCurrentUser />
            &nbsp;in&nbsp;
            <NavStoreName />
          </Caption>
          <Caption>
            <SignOutButton />
          </Caption>
        </HeaderNav>
      </HeaderMainBar>
    </LunaHeader>
  )
}
export default NavHeader
